import { render } from "./StickyTopPolicyCard.vue?vue&type=template&id=ac5460b6&scoped=true"
import script from "./StickyTopPolicyCard.vue?vue&type=script&lang=js"
export * from "./StickyTopPolicyCard.vue?vue&type=script&lang=js"

import "./StickyTopPolicyCard.vue?vue&type=style&index=0&id=ac5460b6&lang=scss&scoped=true"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac5460b6"]])

export default __exports__